import React from "react";
import { Modal } from "react-bootstrap";
import dateFormat from "dateformat";
const NFTHistoryDetails = ({ setShow, singleDataId, show }) => {
  function ModalComponent(props) {
    return (
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="announcement-modal-show notices-modal-show "
        backdrop="static"
      >
        <div className="announcement-header">
          <h4>Details</h4>
          <button onClick={() => setShow(false)}>
            <i className="fa-solid fa-xmark"></i>
          </button>
        </div>
        <Modal.Body>
          <div className="history-details-modal-area">
            <div className="container">
              <div className="history-details-modal-item">
                <p>Name</p>
                <span>{singleDataId?.coin_id?.name}</span>
              </div>
              <div className="history-details-modal-item">
                <p>Symbol</p>
                <span>{singleDataId?.coin_id?.symbol}</span>
              </div>
              <div className="history-details-modal-item">
                <p>NFT</p>
                <span>{singleDataId?.coin_amount}</span>
              </div>
              <div className="history-details-modal-item">
                <p>Buy/Sell</p>
                <span>{singleDataId?.type}</span>
              </div>
              <div className="history-details-modal-item">
                <p>Date</p>
                <span>
                  {dateFormat(singleDataId?.createdAt, "mmm,")}&nbsp;
                  {dateFormat(singleDataId?.createdAt, "dS")}&nbsp;
                  {dateFormat(singleDataId?.createdAt, "yyyy")}
                </span>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
  return (
    <>
      <ModalComponent show={show} onHide={() => setShow(false)} />
    </>
  );
};

export default NFTHistoryDetails;
